export default "__VITE_ASSET__XBBMk41y__"